import React from "react";
import { AddAction, ActionButton } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

const ActionButtons = ({ intl, showListButton = false }) => (
  <>
    <Restricted permissions={[permissions.event_manage]}>
      <AddAction url="/event/new" />
    </Restricted>
    <Restricted permissions={[permissions.event_view]}>
      <ActionButton 
        icon="calendar-today" 
        url="/event/agenda" 
        tooltipText={intl.formatMessage({ id: "app.page.event.agenda" })}
      />
    </Restricted>
    {showListButton && (
      <Restricted permissions={[permissions.event_view]}>
        <ActionButton 
          icon="list" 
          url="/event/list" 
          tooltipText={intl.formatMessage({ id: "app.page.event.list" })}
        />
      </Restricted>
    )}
  </>
);

ActionButtons.propTypes = {
  /**
   * Indica si se debe mostrar el botón de lista de eventos
   * Solo debe mostrarse cuando el componente se renderiza en la página de inicio
   **/
  showListButton: PropTypes.bool,
  /**
   * React Intl object para internacionalización
   **/
  intl: PropTypes.object.isRequired,
};

export default injectIntl(ActionButtons);
